module.exports = __webpack_public_path__ + "static/media/statueofliberty.f5632e53.jpg";